import { View } from '@play-co/timestep-core/ui';
import PopupBasic from './PopupBasic';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { FlexBoxView, getFlexNode } from '@play-co/timestep-core/flexbox';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import uiConfig from '../../../lib/ui/config';
import sounds from 'src/lib/sounds';
import i18n from 'src/lib/i18n/i18n';

import { AssetGroup } from '@play-co/timestep-core';

export default class PopupConfirmationWhite extends PopupBasic {
  private titleText: LangBitmapFontTextView;
  private messageText: LangBitmapFontTextView;
  private buttonOk: ButtonScaleViewWithText;
  private buttonCancel: ButtonScaleViewWithText;

  constructor(opts: { superview: View; close: (result: boolean) => void }) {
    super({
      ...opts,
      width: 556,
      height: 380,
      boxOpts: {
        image: `assets/ui/popups/dialog_panel.png`,
        scaleMethod: '9slice',
        sourceSlices: {
          horizontal: { left: 72, right: 72 },
          vertical: { top: 72, bottom: 72 },
        },
      },
      tracking: {
        feature: 'popup-confirmation',
        $subFeature: 'popup-confirmation-white',
      },
      skipTitle: true,
      close: () => opts.close(false),
    });

    this.buttonClose.removeFromSuperview();

    const layout = new FlexBoxView({
      superview: this.box,
      width: this.box.style.width,
      height: this.box.style.height,
      flex: {
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      },
    });

    this.titleText = new LangBitmapFontTextView({
      superview: layout,
      color: '#9A7171',
      size: 40,
      align: 'center',
      verticalAlign: 'center',
      font: 'Body',
      width: 556,
      height: 60,
    });

    getFlexNode(this.titleText).updateStyle({
      marginBottom: 10,
    });

    //  Separator
    new View({
      superview: layout,
      height: 5,
      width: 443,
      backgroundColor: '#deedfa',
    });

    this.messageText = new LangBitmapFontTextView({
      superview: layout,
      color: '#CD9090',
      size: 34,
      align: 'center',
      verticalAlign: 'center',
      font: 'Body',
      width: 556,
      height: 140,
    });

    const controls = new FlexBoxView({
      superview: layout,
      width: layout.style.width - 60,
      height: 100,
      flex: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-around',
      },
    });

    this.buttonCancel = new ButtonScaleViewWithText({
      superview: controls,
      ...uiConfig.buttons.cancel,
      fontSize: 48,
      font: 'Body',
      width: 228,
      height: 82,
      x: (this.box.style.width - 228) * 0.5,
      y: 930,
      labelOffsetX: -6,
      labelOffsetY: -2,
      localeText: () => i18n('frenzy.airplane.button'),
      onClick: async () => {
        sounds.sfx.play('cancel');
        opts.close(false);
      },
      tracking: {
        feature: 'popup-confirmation',
        $subFeature: 'popup-confirmation-cancel',
      },
    });

    this.buttonOk = new ButtonScaleViewWithText({
      superview: controls,
      ...uiConfig.buttons.secondary,
      fontSize: 48,
      font: 'Body',
      width: 228,
      height: 82,
      x: (this.box.style.width - 228) * 0.5,
      y: 930,
      labelOffsetX: -6,
      labelOffsetY: -2,
      localeText: () => i18n('frenzy.airplane.button'),
      onClick: async () => {
        sounds.sfx.play('ok');
        opts.close(true);
      },
      tracking: {
        feature: 'popup-confirmation',
        $subFeature: 'popup-confirmation-ok',
      },
    });
  }

  protected getAssetsGroup() {
    return new AssetGroup(['assets/ui/popups/dialog_panel.png']);
  }

  public init(opts: {
    title: string;
    message: string;
    buttonOkText: string;
    buttonCancelText: string;
  }): void {
    super.init({});

    this.titleText.localeText = () => opts.title;
    this.messageText.localeText = () => opts.message;
    this.buttonOk.localeText = () => opts.buttonOkText;
    this.buttonCancel.localeText = () => opts.buttonCancelText;
  }
}
